import StaffRegistrationListTable from './StaffRegistrationListTable';

export default StaffRegistrationListTable;
    